module.exports = __webpack_public_path__ + "testimonial-quote-bottom.png?967066564ebbfd5ecc0292762e2b480b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/testimonial-quote-bottom.png
// module id = 23
// module chunks = 0